import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";

export default function NotFound() {
  return (
    <div className="min-h-screen bg-[#FAFAFA] grid place-items-center">
      <div className="text-center" data-testid="not-found-page">
        <div className="font-mono text-xs text-zinc-400">404</div>
        <h1 className="font-display text-4xl font-semibold text-zinc-950 mt-2">Not found</h1>
        <p className="text-zinc-600 mt-2">That component doesn’t exist.</p>
        <Link to="/" className="inline-block mt-6">
          <Button className="rounded-md bg-zinc-950 text-white hover:bg-zinc-800" data-testid="not-found-home-btn">
            Back home
          </Button>
        </Link>
      </div>
    </div>
  );
}
